import { IItemOrcamento } from "app/types/IItemOrcamento";
import { IOrcamento } from "app/types/IOrcamento";

export function corrigirDatasItemOrcamento(item: IItemOrcamento): IItemOrcamento {

    const dataPrecisaSerAjustada = (data:string) : boolean => data?.match?.(new RegExp(/\/Date\(\d+\)\//)) != null

    const ajustarData = (timestamp:number) : string => new Date(timestamp).toISOString().substring(0,10) + "T00:00:00"

    const extrairTimestamp = (data:string) : number => Number(data.match(new RegExp(/\d+/))[0])

    return { 
        ...item,
        DataPrevisaoEntrega: !dataPrecisaSerAjustada(item.DataPrevisaoEntrega) ? item.DataPrevisaoEntrega : ajustarData(extrairTimestamp(item.DataPrevisaoEntrega)),
        DataMarcadaEntrega: !dataPrecisaSerAjustada(item.DataMarcadaEntrega) ? item.DataMarcadaEntrega : ajustarData(extrairTimestamp(item.DataMarcadaEntrega))
    }
}